import React, { useEffect, useState } from 'react';
import Media from 'react-media';
import { ConfirmationModal } from '@kaizen/draft-modal';
import { Text } from '@kaizen/component-library';
import { MEDIA_QUERIES } from '../constants';

export type Props = {
  onDismiss: (wasConfirmed: boolean) => void;
  uiText: {
    close: string;
    confirmMultiple: string;
    confirmSingle: string;
    confirmShort: string;
    description: string;
    titleLong: string;
    titleShort: string;
  };
  unansweredCount: number;
};

type ContentProps = {
  children: React$Node;
  isOpen: boolean;
  onDismiss: () => void;
};

function Content({
  children,
  isOpen,
  onDismiss,
}: ContentProps): React$Element<string> {
  // Allow the modal to animate out before calling onDismiss
  useEffect(() => {
    return () => {
      if (!isOpen) {
        onDismiss();
      }
    };
  }, [isOpen, onDismiss]);

  return <>{children}</>;
}

function UnansweredMandatoryQuestionsModal({
  uiText,
  onDismiss,
  unansweredCount,
}: Props): React$Element<string> {
  const [isOpen, setIsOpen] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  return (
    <Media queries={MEDIA_QUERIES}>
      {(matches) => {
        const title = matches.mobile ? uiText.titleShort : uiText.titleLong;
        let confirmLabel =
          unansweredCount > 1 ? uiText.confirmMultiple : uiText.confirmSingle;
        if (matches.mobile) {
          confirmLabel = uiText.confirmShort;
        }
        return (
          <ConfirmationModal
            mood="negative"
            isProminent
            isOpen={isOpen}
            title={title}
            dismissLabel={uiText.close}
            confirmLabel={confirmLabel}
            onConfirm={(): void => {
              setIsOpen(false);
              setConfirmed(true);
            }}
            onDismiss={(): void => {
              setIsOpen(false);
            }}
          >
            <Content onDismiss={() => onDismiss(confirmed)} isOpen={isOpen}>
              <Text tag="p" inline>
                {uiText.description}
              </Text>
            </Content>
          </ConfirmationModal>
        );
      }}
    </Media>
  );
}

export default UnansweredMandatoryQuestionsModal;
